import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { Social } from "@/components/signup/account-creation/components/social/social";
import { useDeferSiteNamingContinueUrl } from "@/components/signup/hooks/use-defer-site-naming-continue-url";

export const LoggedOutJiraProductTourAccountCreation = () => {
    const getContinueUrl = useDeferSiteNamingContinueUrl();

    return (
        <AccountCreation
            Login={null}
            Social={<Social providers={{ google: "Google" }} />}
            getContinueUrl={getContinueUrl}
        />
    );
};
